import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function PaymentCallbackPage() {
  const [params] = useSearchParams();
  const reference = params.get("reference") || params.get("trxref");
  const [state, setState] = useState({ loading: true, success: false, orderId: null });
  const navigate = useNavigate();

  useEffect(() => {
    if (!reference) {
      setState({ loading: false, success: false, orderId: null });
      return;
    }
    api.get(`/payments/paystack/verify/${reference}`)
      .then((r) => {
        const s = r.data?.status === "success";
        setState({ loading: false, success: s, orderId: r.data?.order_id });
        if (s && r.data?.order_id) {
          setTimeout(() => navigate(`/receipt/${r.data.order_id}`), 1500);
        }
      })
      .catch(() => setState({ loading: false, success: false, orderId: null }));
  }, [reference, navigate]);

  return (
    <div className="max-w-xl mx-auto p-16 text-center" data-testid="payment-callback-page">
      {state.loading ? (
        <>
          <h1 className="font-serif text-3xl mb-4">Verifying your payment…</h1>
          <p className="text-[#6A747D]">Please wait while we confirm your transaction.</p>
        </>
      ) : state.success ? (
        <>
          <h1 className="font-serif text-3xl mb-4">Payment confirmed</h1>
          <p className="text-[#6A747D]">Redirecting to your receipt…</p>
        </>
      ) : (
        <>
          <h1 className="font-serif text-3xl mb-4">Payment failed</h1>
          <p className="text-[#6A747D] mb-6">We couldn't verify your transaction.</p>
          <Link to="/cart" className="btn-gold">Return to Cart</Link>
        </>
      )}
    </div>
  );
}
